import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'

const Masonry = ({ columns, children, childrenClassName }) => {
  const {
    common: { isMobile }
  } = useSelector((state) => state)

  const columnWrapper = {}
  const result = []

  // create columns
  for (let i = 0; i < columns; i++) {
    columnWrapper[`column${i}`] = []
  }

  // divide children into columns
  for (let i = 0; i < children.length; i++) {
    const columnIndex = i % columns
    columnWrapper[`column${columnIndex}`].push(
      <div className={styles.divider} key={i}>
        {children[i]}
      </div>
    )
  }

  // wrap children in each column with a div
  for (let i = 0; i < columns; i++) {
    result.push(
      <div className={`${styles.children} ${childrenClassName} ${i > 0 ? styles.gap : styles.nogap}`} key={i}>
        {columnWrapper[`column${i}`]}
      </div>
    )
  }

  if (isMobile) {
    return result
  }

  return (
    <div className={`${styles.masonryWrapper} ${children.length > columns && styles.centeredMasonryWrapper}`}>
      {result}
    </div>
  )
}

Masonry.propTypes = {
  columns: PropTypes.number.isRequired,
  children: PropTypes.arrayOf(PropTypes.element)
}

Masonry.defaultProps = {
  columns: 2
}

export default Masonry
